import { useState } from 'react';
import { MapPin, Move } from 'lucide-react';
import CnibMap from './CnibMap';

/**
 * Mapa pequeño con un pin arrastrable para seleccionar lat/lng.
 * - value: {lat, lng} o null
 * - onChange: ({lat,lng}) => void
 * - color: color del pin (hex)
 * - icon: 'home'|'dot'|'building'|'map'
 */
export default function MapPinPicker({ value, onChange, color = '#F97316', icon = 'dot', height = 'h-72', testid = 'map-pin-picker' }) {
  const [hasPin, setHasPin] = useState(!!value);
  const handleMapClick = ({ lat, lng }) => {
    setHasPin(true);
    onChange?.({ lat, lng });
  };
  const markers = value
    ? [{
        id: 'picker-pin',
        lat: value.lat, lng: value.lng,
        color, icon, size: 'lg',
        draggable: true,
        onDragEnd: ({ lat, lng }) => onChange?.({ lat, lng }),
      }]
    : [];

  return (
    <div data-testid={testid}>
      <div className="mb-2 flex items-center gap-2 rounded-xl bg-slate-50 px-3 py-2 text-xs text-slate-600">
        {hasPin ? (
          <>
            <Move className="h-3.5 w-3.5 text-violet-500" />
            <span>Arrastra el pin para ajustar.</span>
            <span className="ml-auto font-mono text-[10px] text-slate-500">
              {value.lat?.toFixed(5)}, {value.lng?.toFixed(5)}
            </span>
          </>
        ) : (
          <>
            <MapPin className="h-3.5 w-3.5 text-orange-500" />
            <span>Haz click en el mapa para colocar la ubicación.</span>
          </>
        )}
      </div>
      <div className={`overflow-hidden rounded-2xl border border-slate-200 ${height}`}>
        <CnibMap
          center={value ? [value.lng, value.lat] : [-63.6, -17.2]}
          zoom={value ? 12 : 5.5}
          markers={markers}
          onMapClick={handleMapClick}
          className={`h-full w-full ${!hasPin ? 'cursor-crosshair' : ''}`}
        />
      </div>
    </div>
  );
}
